import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4885d110"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-xxl" }
const _hoisted_2 = { class: "d-flex flex-column h-100 justify-content-lg-center" }
const _hoisted_3 = { class: "w-lg-500px bg-white w-100 rounded p-10 m-10 p-lg-15 mx-auto" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-center mb-10" }
const _hoisted_6 = { class: "text-main mb-3" }
const _hoisted_7 = { class: "row row-gap" }
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = {
  class: "btn btn-outline btn-outline-dashed p-7 d-flex align-items-center",
  for: "kt_create_account_form_account_type_cloud"
}
const _hoisted_10 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_11 = { class: "d-block fw-bold text-start" }
const _hoisted_12 = { class: "text-main fw-bolder d-block fs-4 mb-2" }
const _hoisted_13 = { class: "text-gray-400 fw-bold fs-6" }
const _hoisted_14 = { class: "col-sm-12" }
const _hoisted_15 = {
  class: "btn btn-outline btn-outline-dashed p-7 d-flex align-items-center",
  for: "kt_create_account_form_account_type_custom"
}
const _hoisted_16 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_17 = { class: "d-block fw-bold text-start" }
const _hoisted_18 = { class: "text-main fw-bolder d-block fs-4 mb-2" }
const _hoisted_19 = { class: "text-gray-400 fw-bold fs-6" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "text-center mb-10" }
const _hoisted_22 = { class: "text-main mb-3" }
const _hoisted_23 = {
  key: 1,
  class: "text-center mb-10"
}
const _hoisted_24 = { class: "text-main mb-3" }
const _hoisted_25 = {
  key: 2,
  class: "row-gap flex-wrap justify-content-center d-flex mb-10"
}
const _hoisted_26 = { class: "" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "kt_hundred_select" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "60",
    height: "60",
    viewBox: "0 0 122 122"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "Group_23449",
      "data-name": "Group 23449",
      transform: "translate(-1382 -794)"
    }, [
      /*#__PURE__*/_createElementVNode("g", {
        id: "Ellipse_8",
        "data-name": "Ellipse 8",
        transform: "translate(1382 794)",
        fill: "#fff",
        stroke: "#1b325f",
        "stroke-width": "1"
      }, [
        /*#__PURE__*/_createElementVNode("circle", {
          cx: "61",
          cy: "61",
          r: "61",
          stroke: "none"
        }),
        /*#__PURE__*/_createElementVNode("circle", {
          cx: "61",
          cy: "61",
          r: "60.5",
          fill: "none"
        })
      ]),
      /*#__PURE__*/_createElementVNode("g", {
        id: "Ellipse_13",
        "data-name": "Ellipse 13",
        transform: "translate(1387 799)",
        fill: "#fff",
        stroke: "#f26c4f",
        "stroke-linecap": "round",
        "stroke-width": "1",
        "stroke-dasharray": "7"
      }, [
        /*#__PURE__*/_createElementVNode("circle", {
          cx: "56",
          cy: "56",
          r: "56",
          stroke: "none"
        }),
        /*#__PURE__*/_createElementVNode("circle", {
          cx: "56",
          cy: "56",
          r: "55.5",
          fill: "none"
        })
      ]),
      /*#__PURE__*/_createElementVNode("text", {
        id: "_100",
        "data-name": "100",
        transform: "translate(1419 868)",
        fill: "#1b325f",
        "font-size": "32",
        "font-family": "TatweerAlRiyadh-Regular, Tatweer Al Riyadh"
      }, [
        /*#__PURE__*/_createElementVNode("tspan", {
          x: "0",
          y: "0"
        }, "100")
      ])
    ])
  ])
], -1))
const _hoisted_28 = { class: "" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "kt_one_thousand_select" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "60",
    height: "60",
    viewBox: "0 0 122 122"
  }, [
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("linearGradient", {
        id: "linear-gradient",
        x1: "0.5",
        y1: "0.123",
        x2: "0.5",
        y2: "1",
        gradientUnits: "objectBoundingBox"
      }, [
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "0",
          "stop-color": "#fff",
          "stop-opacity": "0.451"
        }),
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "1",
          "stop-color": "gray",
          "stop-opacity": "0.878"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("g", {
      id: "Group_23450",
      "data-name": "Group 23450",
      transform: "translate(-1244 -794)"
    }, [
      /*#__PURE__*/_createElementVNode("g", {
        id: "Ellipse_9",
        "data-name": "Ellipse 9",
        transform: "translate(1244 794)",
        fill: "#fff",
        stroke: "#1b325f",
        "stroke-width": "1"
      }, [
        /*#__PURE__*/_createElementVNode("circle", {
          cx: "61",
          cy: "61",
          r: "61",
          stroke: "none"
        }),
        /*#__PURE__*/_createElementVNode("circle", {
          cx: "61",
          cy: "61",
          r: "60.5",
          fill: "none"
        })
      ]),
      /*#__PURE__*/_createElementVNode("g", {
        id: "Ellipse_14",
        "data-name": "Ellipse 14",
        transform: "translate(1249 799)",
        fill: "#fff",
        stroke: "#cccaca",
        "stroke-linecap": "round",
        "stroke-width": "1",
        "stroke-dasharray": "7"
      }, [
        /*#__PURE__*/_createElementVNode("circle", {
          cx: "56",
          cy: "56",
          r: "56",
          stroke: "none"
        }),
        /*#__PURE__*/_createElementVNode("circle", {
          cx: "56",
          cy: "56",
          r: "55.5",
          fill: "none"
        })
      ]),
      /*#__PURE__*/_createElementVNode("text", {
        id: "_1000",
        "data-name": "1000",
        transform: "translate(1268 869)",
        fill: "#d4d4d4",
        "font-size": "32",
        "font-family": "TatweerAlRiyadh-Regular, Tatweer Al Riyadh"
      }, [
        /*#__PURE__*/_createElementVNode("tspan", {
          x: "0",
          y: "0"
        }, "1000")
      ]),
      /*#__PURE__*/_createElementVNode("circle", {
        id: "Ellipse_22",
        "data-name": "Ellipse 22",
        cx: "61",
        cy: "61",
        r: "61",
        transform: "translate(1244 794)",
        fill: "url(#linear-gradient)"
      }),
      /*#__PURE__*/_createElementVNode("g", {
        id: "Lock",
        transform: "translate(1282.763 835.926)"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          id: "Path_18658",
          "data-name": "Path 18658",
          d: "M31.136,15.124H30.023V11.787a7.787,7.787,0,0,0-15.574,0v3.337H13.337A3.341,3.341,0,0,0,10,18.461V31.81a3.341,3.341,0,0,0,3.337,3.337h17.8a3.341,3.341,0,0,0,3.337-3.337V18.461A3.341,3.341,0,0,0,31.136,15.124ZM16.674,11.787a5.562,5.562,0,0,1,11.124,0v3.337H16.674ZM32.248,31.81a1.114,1.114,0,0,1-1.112,1.112h-17.8a1.114,1.114,0,0,1-1.112-1.112V18.461a1.114,1.114,0,0,1,1.112-1.112h17.8a1.114,1.114,0,0,1,1.112,1.112Z",
          fill: "#1b325f"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          id: "Path_18659",
          "data-name": "Path 18659",
          d: "M30.225,35a2.218,2.218,0,0,0-1.112,4.14v2.534a1.112,1.112,0,1,0,2.225,0V39.14A2.218,2.218,0,0,0,30.225,35Z",
          transform: "translate(-7.988 -13.758)",
          fill: "#1b325f"
        })
      ])
    ])
  ])
], -1))
const _hoisted_30 = { class: "" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "kt_five_thousand_select" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "60",
    height: "60",
    viewBox: "0 0 122 122"
  }, [
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("linearGradient", {
        id: "linear-gradient",
        x1: "0.5",
        y1: "0.123",
        x2: "0.5",
        y2: "1",
        gradientUnits: "objectBoundingBox"
      }, [
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "0",
          "stop-color": "#fff",
          "stop-opacity": "0.451"
        }),
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "1",
          "stop-color": "gray",
          "stop-opacity": "0.878"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("g", {
      id: "Group_23451",
      "data-name": "Group 23451",
      transform: "translate(-1106 -794)"
    }, [
      /*#__PURE__*/_createElementVNode("g", {
        id: "Ellipse_10",
        "data-name": "Ellipse 10",
        transform: "translate(1106 794)",
        fill: "#fff",
        stroke: "#1b325f",
        "stroke-width": "1"
      }, [
        /*#__PURE__*/_createElementVNode("circle", {
          cx: "61",
          cy: "61",
          r: "61",
          stroke: "none"
        }),
        /*#__PURE__*/_createElementVNode("circle", {
          cx: "61",
          cy: "61",
          r: "60.5",
          fill: "none"
        })
      ]),
      /*#__PURE__*/_createElementVNode("g", {
        id: "Ellipse_15",
        "data-name": "Ellipse 15",
        transform: "translate(1111 799)",
        fill: "#fff",
        stroke: "#cccaca",
        "stroke-linecap": "round",
        "stroke-width": "1",
        "stroke-dasharray": "7"
      }, [
        /*#__PURE__*/_createElementVNode("circle", {
          cx: "56",
          cy: "56",
          r: "56",
          stroke: "none"
        }),
        /*#__PURE__*/_createElementVNode("circle", {
          cx: "56",
          cy: "56",
          r: "55.5",
          fill: "none"
        })
      ]),
      /*#__PURE__*/_createElementVNode("text", {
        id: "_5000",
        "data-name": "5000",
        transform: "translate(1130 869)",
        fill: "#d4d4d4",
        "font-size": "32",
        "font-family": "TatweerAlRiyadh-Regular, Tatweer Al Riyadh"
      }, [
        /*#__PURE__*/_createElementVNode("tspan", {
          x: "0",
          y: "0"
        }, "5000")
      ]),
      /*#__PURE__*/_createElementVNode("circle", {
        id: "Ellipse_23",
        "data-name": "Ellipse 23",
        cx: "61",
        cy: "61",
        r: "61",
        transform: "translate(1106 794)",
        fill: "url(#linear-gradient)"
      }),
      /*#__PURE__*/_createElementVNode("g", {
        id: "Lock",
        transform: "translate(1144.763 835.926)"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          id: "Path_18658",
          "data-name": "Path 18658",
          d: "M31.136,15.124H30.023V11.787a7.787,7.787,0,0,0-15.574,0v3.337H13.337A3.341,3.341,0,0,0,10,18.461V31.81a3.341,3.341,0,0,0,3.337,3.337h17.8a3.341,3.341,0,0,0,3.337-3.337V18.461A3.341,3.341,0,0,0,31.136,15.124ZM16.674,11.787a5.562,5.562,0,0,1,11.124,0v3.337H16.674ZM32.248,31.81a1.114,1.114,0,0,1-1.112,1.112h-17.8a1.114,1.114,0,0,1-1.112-1.112V18.461a1.114,1.114,0,0,1,1.112-1.112h17.8a1.114,1.114,0,0,1,1.112,1.112Z",
          fill: "#1b325f"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          id: "Path_18659",
          "data-name": "Path 18659",
          d: "M30.225,35a2.218,2.218,0,0,0-1.112,4.14v2.534a1.112,1.112,0,1,0,2.225,0V39.14A2.218,2.218,0,0,0,30.225,35Z",
          transform: "translate(-7.988 -13.758)",
          fill: "#1b325f"
        })
      ])
    ])
  ])
], -1))
const _hoisted_32 = { class: "" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "kt_ten_thousand_select" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "60",
    height: "60",
    viewBox: "0 0 122 122"
  }, [
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("linearGradient", {
        id: "linear-gradient",
        x1: "0.5",
        y1: "0.123",
        x2: "0.5",
        y2: "1",
        gradientUnits: "objectBoundingBox"
      }, [
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "0",
          "stop-color": "#fff",
          "stop-opacity": "0.451"
        }),
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "1",
          "stop-color": "gray",
          "stop-opacity": "0.878"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("g", {
      id: "Group_23452",
      "data-name": "Group 23452",
      transform: "translate(-968 -794)"
    }, [
      /*#__PURE__*/_createElementVNode("g", {
        id: "Ellipse_11",
        "data-name": "Ellipse 11",
        transform: "translate(968 794)",
        fill: "#fff",
        stroke: "#707070",
        "stroke-width": "1"
      }, [
        /*#__PURE__*/_createElementVNode("circle", {
          cx: "61",
          cy: "61",
          r: "61",
          stroke: "none"
        }),
        /*#__PURE__*/_createElementVNode("circle", {
          cx: "61",
          cy: "61",
          r: "60.5",
          fill: "none"
        })
      ]),
      /*#__PURE__*/_createElementVNode("g", {
        id: "Ellipse_16",
        "data-name": "Ellipse 16",
        transform: "translate(973 799)",
        fill: "#fff",
        stroke: "#cccaca",
        "stroke-linecap": "round",
        "stroke-width": "1",
        "stroke-dasharray": "7"
      }, [
        /*#__PURE__*/_createElementVNode("circle", {
          cx: "56",
          cy: "56",
          r: "56",
          stroke: "none"
        }),
        /*#__PURE__*/_createElementVNode("circle", {
          cx: "56",
          cy: "56",
          r: "55.5",
          fill: "none"
        })
      ]),
      /*#__PURE__*/_createElementVNode("text", {
        id: "_10000",
        "data-name": "10000",
        transform: "translate(983 869)",
        fill: "#d4d4d4",
        "font-size": "32",
        "font-family": "TatweerAlRiyadh-Regular, Tatweer Al Riyadh"
      }, [
        /*#__PURE__*/_createElementVNode("tspan", {
          x: "0",
          y: "0"
        }, "10000")
      ]),
      /*#__PURE__*/_createElementVNode("circle", {
        id: "Ellipse_24",
        "data-name": "Ellipse 24",
        cx: "61",
        cy: "61",
        r: "61",
        transform: "translate(968 794)",
        fill: "url(#linear-gradient)"
      }),
      /*#__PURE__*/_createElementVNode("g", {
        id: "Lock",
        transform: "translate(1006.763 835.926)"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          id: "Path_18658",
          "data-name": "Path 18658",
          d: "M31.136,15.124H30.023V11.787a7.787,7.787,0,0,0-15.574,0v3.337H13.337A3.341,3.341,0,0,0,10,18.461V31.81a3.341,3.341,0,0,0,3.337,3.337h17.8a3.341,3.341,0,0,0,3.337-3.337V18.461A3.341,3.341,0,0,0,31.136,15.124ZM16.674,11.787a5.562,5.562,0,0,1,11.124,0v3.337H16.674ZM32.248,31.81a1.114,1.114,0,0,1-1.112,1.112h-17.8a1.114,1.114,0,0,1-1.112-1.112V18.461a1.114,1.114,0,0,1,1.112-1.112h17.8a1.114,1.114,0,0,1,1.112,1.112Z",
          fill: "#1b325f"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          id: "Path_18659",
          "data-name": "Path 18659",
          d: "M30.225,35a2.218,2.218,0,0,0-1.112,4.14v2.534a1.112,1.112,0,1,0,2.225,0V39.14A2.218,2.218,0,0,0,30.225,35Z",
          transform: "translate(-7.988 -13.758)",
          fill: "#1b325f"
        })
      ])
    ])
  ])
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "radio",
    class: "btn-check",
    name: "invoice_plan",
    value: "other",
    disabled: "",
    id: "kt_other_select"
  }),
  /*#__PURE__*/_createElementVNode("label", { for: "kt_other_select" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      width: "60",
      height: "60",
      viewBox: "0 0 122 122"
    }, [
      /*#__PURE__*/_createElementVNode("defs", null, [
        /*#__PURE__*/_createElementVNode("linearGradient", {
          id: "linear-gradient",
          x1: "0.5",
          y1: "0.123",
          x2: "0.5",
          y2: "1",
          gradientUnits: "objectBoundingBox"
        }, [
          /*#__PURE__*/_createElementVNode("stop", {
            offset: "0",
            "stop-color": "#fff",
            "stop-opacity": "0.451"
          }),
          /*#__PURE__*/_createElementVNode("stop", {
            offset: "1",
            "stop-color": "gray",
            "stop-opacity": "0.878"
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("g", {
        id: "Group_23453",
        "data-name": "Group 23453",
        transform: "translate(-830 -794)"
      }, [
        /*#__PURE__*/_createElementVNode("g", {
          id: "Ellipse_12",
          "data-name": "Ellipse 12",
          transform: "translate(830 794)",
          fill: "#fff",
          stroke: "#707070",
          "stroke-width": "1"
        }, [
          /*#__PURE__*/_createElementVNode("circle", {
            cx: "61",
            cy: "61",
            r: "61",
            stroke: "none"
          }),
          /*#__PURE__*/_createElementVNode("circle", {
            cx: "61",
            cy: "61",
            r: "60.5",
            fill: "none"
          })
        ]),
        /*#__PURE__*/_createElementVNode("g", {
          id: "Ellipse_17",
          "data-name": "Ellipse 17",
          transform: "translate(835 799)",
          fill: "#fff",
          stroke: "#cccaca",
          "stroke-linecap": "round",
          "stroke-width": "1",
          "stroke-dasharray": "7"
        }, [
          /*#__PURE__*/_createElementVNode("circle", {
            cx: "56",
            cy: "56",
            r: "56",
            stroke: "none"
          }),
          /*#__PURE__*/_createElementVNode("circle", {
            cx: "56",
            cy: "56",
            r: "55.5",
            fill: "none"
          })
        ]),
        /*#__PURE__*/_createElementVNode("text", {
          id: "أخرى",
          transform: "translate(866 864)",
          fill: "#d4d4d4",
          "font-size": "32",
          "font-family": "TatweerAlRiyadh-Regular, Tatweer Al Riyadh"
        }, [
          /*#__PURE__*/_createElementVNode("tspan", {
            x: "0",
            y: "0"
          }, "أخرى")
        ]),
        /*#__PURE__*/_createElementVNode("circle", {
          id: "Ellipse_25",
          "data-name": "Ellipse 25",
          cx: "61",
          cy: "61",
          r: "61",
          transform: "translate(830 794)",
          fill: "url(#linear-gradient)"
        }),
        /*#__PURE__*/_createElementVNode("g", {
          id: "Lock",
          transform: "translate(868.763 835.926)"
        }, [
          /*#__PURE__*/_createElementVNode("path", {
            id: "Path_18658",
            "data-name": "Path 18658",
            d: "M31.136,15.124H30.023V11.787a7.787,7.787,0,0,0-15.574,0v3.337H13.337A3.341,3.341,0,0,0,10,18.461V31.81a3.341,3.341,0,0,0,3.337,3.337h17.8a3.341,3.341,0,0,0,3.337-3.337V18.461A3.341,3.341,0,0,0,31.136,15.124ZM16.674,11.787a5.562,5.562,0,0,1,11.124,0v3.337H16.674ZM32.248,31.81a1.114,1.114,0,0,1-1.112,1.112h-17.8a1.114,1.114,0,0,1-1.112-1.112V18.461a1.114,1.114,0,0,1,1.112-1.112h17.8a1.114,1.114,0,0,1,1.112,1.112Z",
            fill: "#1b325f"
          }),
          /*#__PURE__*/_createElementVNode("path", {
            id: "Path_18659",
            "data-name": "Path 18659",
            d: "M30.225,35a2.218,2.218,0,0,0-1.112,4.14v2.534a1.112,1.112,0,1,0,2.225,0V39.14A2.218,2.218,0,0,0,30.225,35Z",
            transform: "translate(-7.988 -13.758)",
            fill: "#1b325f"
          })
        ])
      ])
    ])
  ])
], -1))
const _hoisted_35 = { class: "text-center mt-14" }
const _hoisted_36 = { class: "indicator-label" }
const _hoisted_37 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_38 = { class: "indicator-progress" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_40 = {
  key: 1,
  class: "text-gray-400 text-center fw-bold fs-4 mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          class: "form w-100",
          onSubmit: _withModifiers(_ctx.signUp, ["prevent"]),
          model: _ctx.formData,
          rules: _ctx.signUpValidator,
          ref: "formSignUp"
        }, {
          default: _withCtx(() => [
            (_ctx.currentStepIndex === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t("chooseAccountType")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "btn-check",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.account_type) = $event)),
                        id: "kt_create_account_form_account_type_cloud",
                        value: "cloud"
                      }, null, 512), [
                        [_vModelRadio, _ctx.formData.account_type]
                      ]),
                      _createElementVNode("label", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com005.svg" })
                        ]),
                        _createElementVNode("span", _hoisted_11, [
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("cloudAccount")), 1),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("checkItOut")), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "btn-check",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.account_type) = $event)),
                        value: "custom",
                        id: "kt_create_account_form_account_type_custom"
                      }, null, 512), [
                        [_vModelRadio, _ctx.formData.account_type]
                      ]),
                      _createElementVNode("label", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/finance/fin006.svg" })
                        ]),
                        _createElementVNode("span", _hoisted_17, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("customAccount")), 1),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("createCorpAccount")), 1)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.currentStepIndex === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("h1", _hoisted_22, _toDisplayString(_ctx.$t("accountInfo")), 1)
                  ]),
                  _createVNode(_component_el_form_item, {
                    class: "mb-8",
                    prop: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "fs-3",
                        modelValue: _ctx.formData.name,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.name) = $event)),
                        type: "text",
                        placeholder: _ctx.$t('name')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    class: "mb-8",
                    prop: "phone"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "fs-3",
                        modelValue: _ctx.formData.phone,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.phone) = $event)),
                        type: "number",
                        placeholder: _ctx.$t('phone')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    class: "mb-8",
                    prop: "email"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "fs-3",
                        modelValue: _ctx.formData.email,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.email) = $event)),
                        type: "email",
                        placeholder: _ctx.$t('email'),
                        autocomplete: "off"
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }),
                  (_ctx.formData.account_type === 'custom')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        prop: "password",
                        class: "mb-12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            class: "fs-3",
                            modelValue: _ctx.formData.password,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.password) = $event)),
                            type: "password",
                            placeholder: _ctx.$t('password'),
                            autocomplete: "off"
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.formData.account_type === 'custom')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("h1", _hoisted_24, _toDisplayString(_ctx.$t("specify_invoice_size")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formData.account_type === 'custom')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            class: "btn-check",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.invoice_plan) = $event)),
                            value: "100",
                            id: "kt_hundred_select"
                          }, null, 512), [
                            [_vModelRadio, _ctx.formData.invoice_plan]
                          ]),
                          _hoisted_27
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            class: "btn-check",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.invoice_plan) = $event)),
                            value: "1000",
                            disabled: "",
                            id: "kt_one_thousand_select"
                          }, null, 512), [
                            [_vModelRadio, _ctx.formData.invoice_plan]
                          ]),
                          _hoisted_29
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            class: "btn-check",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.invoice_plan) = $event)),
                            value: "5000",
                            disabled: "",
                            id: "kt_five_thousand_select"
                          }, null, 512), [
                            [_vModelRadio, _ctx.formData.invoice_plan]
                          ]),
                          _hoisted_31
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            class: "btn-check",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.invoice_plan) = $event)),
                            value: "10000",
                            disabled: "",
                            id: "kt_ten_thousand_select"
                          }, null, 512), [
                            [_vModelRadio, _ctx.formData.invoice_plan]
                          ]),
                          _hoisted_33
                        ]),
                        _hoisted_34
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_35, [
              (_ctx.currentStepIndex === 2)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    ref: "submitButton",
                    class: "btn btn-lg px-18 fs-1 btn-primary",
                    onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.signUp()), ["prevent"]))
                  }, [
                    _createElementVNode("span", _hoisted_36, [
                      _createTextVNode(_toDisplayString(_ctx.$t("signUp")) + " ", 1),
                      _createElementVNode("span", _hoisted_37, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_38, [
                      _createTextVNode(_toDisplayString(_ctx.$t("pleaseWait")) + " ", 1),
                      _hoisted_39
                    ])
                  ], 512))
                : _createCommentVNode("", true),
              (_ctx.currentStepIndex === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createTextVNode(_toDisplayString(_ctx.$t("already_registered")) + " ", 1),
                    _createVNode(_component_router_link, {
                      to: { name: 'sign-in' },
                      class: "fw-bolder text-decoration-underline"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("signIn")), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.currentStepIndex = 2), ["prevent"])),
                    class: "btn btn-lg px-18 fs-1 btn-primary"
                  }, _toDisplayString(_ctx.$t("continue")), 1))
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "model", "rules"])
      ])
    ])
  ]))
}